import { action } from 'satcheljs';
import type LayoutChangeSource from '../store/schema/LayoutChangeSource';

export interface OnWindowResizeActionMessage {
    browserHeight: number;
    browserWidth: number;
    layoutChangeSource: LayoutChangeSource;
}
export const onWindowResize: (
    browserHeight: number,
    browserWidth: number,
    layoutChangeSource: LayoutChangeSource
) => OnWindowResizeActionMessage = action(
    'onWindowResize',
    (
        browserHeight: number,
        browserWidth: number,
        layoutChangeSource: LayoutChangeSource
    ): OnWindowResizeActionMessage => ({
        browserHeight,
        browserWidth,
        layoutChangeSource,
    })
);
